'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post(slug, title, category, readTime, alt, imageIndex, intro, sections) {
  this.dl = null;
  this.dm = null;
  this.fv = null;
  this.fx = null;
  this.fu = null;
  this.fw = 0;
  this.ej = null;
  this.gj = null;
  this.dl = slug;
  this.dm = title;
  this.fv = category;
  this.fx = readTime;
  this.fu = alt;
  this.fw = imageIndex;
  this.ej = intro;
  this.gj = sections;
}
export { $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post as $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post };
$p = $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Post() {
}
export { $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Post as $h_Lio_intela_sites_digitalinternship_data_BlogPosts$Post };
$h_Lio_intela_sites_digitalinternship_data_BlogPosts$Post.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, 2493632);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.dl));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.dm));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.fv));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.fx));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.fu));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.fw);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.ej));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().E(this.gj));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().Q(acc, 8);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post)) {
    if ((((((((this.fw === x$0.fw) && (this.dl === x$0.dl)) && (this.dm === x$0.dm)) && (this.fv === x$0.fv)) && (this.fx === x$0.fx)) && (this.fu === x$0.fu)) && (this.ej === x$0.ej))) {
      var x = this.gj;
      var x$2 = x$0.gj;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 8;
});
$p.I = (function() {
  return "Post";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.dl;
      break;
    }
    case 1: {
      return this.dm;
      break;
    }
    case 2: {
      return this.fv;
      break;
    }
    case 3: {
      return this.fx;
      break;
    }
    case 4: {
      return this.fu;
      break;
    }
    case 5: {
      return this.fw;
      break;
    }
    case 6: {
      return this.ej;
      break;
    }
    case 7: {
      return this.gj;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Post(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bp)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Post as $isArrayOf_Lio_intela_sites_digitalinternship_data_BlogPosts$Post };
var $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Post = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_BlogPosts$Post, "io.intela.sites.digitalinternship.data.BlogPosts$Post", ({
  bp: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Post as $d_Lio_intela_sites_digitalinternship_data_BlogPosts$Post };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Blog-Posts$-Post.js.map
